import React from 'react';

export function PageNotFound() {
    return (
        <div className="m-5 p-5" style={{ height: 700 }}>
            404 error - this page doesn't exist
        </div>
    );
}
